/**
 * 📱 BottomTabBar — sticky bottom nav with the most-used destinations.
 *
 * Mar 4, 2026 owner canon: the LOOT box slot was retired here and
 * replaced by 🗺️ Areas — a discovery hub that lists every unlocked
 * area / dungeon (Dream Forest, and future zones). The Daily Mystery
 * Box still exists via LootHub; it just no longer takes the fourth
 * tab. Any component listening for `omni:claim-mystery-box` still
 * works — it just fires from LootHub / the /loot page instead.
 */
import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";

const TABS = [
  { id: "arena",  label: "Arena",  icon: "⚔️", path: "/arena" },
  { id: "pet",    label: "Pet",    icon: "🐦", path: "/pet" },
  { id: "areas",  label: "Areas",  icon: "🗺️", path: "/areas" },
  { id: "forums", label: "Forums", icon: "💬", path: "/forums" },
];

export default function BottomTabBar() {
  const { user } = useAuth();
  const [pathname, setPathname] = useState(typeof window !== "undefined" ? window.location.pathname : "/");

  useEffect(() => {
    const onPop = () => setPathname(window.location.pathname);
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  if (!user) return null;

  const go = (path) => {
    if (window.location.pathname !== path) window.location.href = path;
  };

  return (
    <nav
      data-testid="bottom-tab-bar"
      className="fixed bottom-0 inset-x-0 z-40 bg-black/90 backdrop-blur-md border-t border-[#D4AF37]/30 grid grid-cols-4 pointer-events-auto"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      {TABS.map((t) => {
        const active = pathname.startsWith(t.path);
        return (
          <button
            key={t.id}
            onClick={() => go(t.path)}
            data-testid={`bottom-tab-${t.id}`}
            className={`py-2.5 flex flex-col items-center justify-center transition-all relative ${
              active
                ? "text-[#FCD34D] bg-gradient-to-t from-[#D4AF37]/20 to-transparent"
                : "text-neutral-400 hover:text-white"
            }`}
          >
            <span className="text-xl leading-none">{t.icon}</span>
            <span className="text-[10px] uppercase tracking-[0.2em] font-bold mt-1">{t.label}</span>
            {active && <span className="absolute bottom-0 h-0.5 w-12 bg-[#FCD34D]" />}
          </button>
        );
      })}
    </nav>
  );
}
